module.exports = __webpack_public_path__ + "media/images/icon-arrow-right-no-fill-f4a380417d12446e4c43596e953bd3f8.svg";